<template>
  <div class="header">
    <!-- Topbar Start -->
    <div class="navbar-custom topnav-navbar navbar-frontDesk">
      <div class="container-fluid">
        <!-- LOGO -->
        <div class="topnav-logo">
          <span class="topnav-logo-lg">
            <img src="@/assets/images/yf_images/logo_bp_l.png" alt="" height="84" />
          </span>
          <span class="topnav-logo-sm">
            <img src="@/assets/images/yf_images/logo_bp_s.png" alt="" height="84" />
          </span>
        </div>
        <!-- LOGO右侧菜单 -->
        <ul class="list-unstyled topbar-right-menu float-right mb-0">
          <li class="dropdown notification-list" v-show="isLogin">
            <a class="nav-link right-bar-toggle nav-home" @click="goBackstage">
              <!-- <i class="fa fa-home noti-icon"></i> -->
              <i class="el-icon-house"></i>
              <span class="align-middle">后台首页</span>
            </a>
          </li>
          <li>
            <Login @login="userLogin" @logout="userLogout"></Login>
          </li>
        </ul>
        <div class="app-search">
          <div>
            <div class="input-group">
              <input type="text" v-model="searchValue" class="form-control" placeholder="站内搜索" />
              <span class="fa fa-search"></span>
              <div class="input-group-append">
                <button class="btn btn-success" type="submit" @click="search">搜 索</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "@/components/Login";
import request from '@/utils/request.js'
import {isTeacherAndHaveLesson} from '@/api/public.js'
export default {
  components: { Login },
  data() {
    return {
      isUserLiLook: false,
			isLogin:false,
			searchValue:'',//搜索内容
    };
  },
	created() {
		this.getIsLogin()
	},
  methods: {
		search(){
			console.log(this.searchValue);
			if (!this.searchValue) {
				this.$message.error('请输入搜索内容！')
				return
			}
			this.$router.push('/searchValueList?keyword=' + this.searchValue)
		},
		// 用户登录动作
		userLogin(){
			this.getIsLogin()
		},
		// 用户登出操作
		userLogout(){
			this.getIsLogin()
		},
		// 获取用户当前是否登录的状态
		getIsLogin(){
			if (sessionStorage.getItem('token')) {
				this.isLogin = true
			}else{
				this.isLogin = false
			}
		},
    async goBackstage() {
      if(sessionStorage.getItem('token')){
        let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        let path='/backstage/topicsDeclaration'
				
				// 如果该用户是系统管理员时才会进入到后台首页
        if(userInfo.roleId.includes('1')){
					path = '/backstage'
        }else if (userInfo.roleId === "") {//如果该用户是普通教师且有在研课题直接跳转到负责的课题
					const res = await isTeacherAndHaveLesson()
					if (res.code == 200) {
						if (res.data) {
							path = '/backstage/myTopic'
						}
					}else{
						this.$message.error(res.data)
					}
        }
				
        let routeUrl = this.$router.resolve({
           path: path,
        });
        window.open(routeUrl.href, '_blank');
      }else{
        this.$message.error("未登录，请先登录");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
